import React from "react";
import css from "@/components/login-alert/loginAlert.module.scss";
import { Button, Modal } from "@aqar-app/react-ui";
import Icon from "@/components/icon";
import RatingStars, { OutlineStar } from "@/components/rateBooking/RatingStars";
import UserReviewsList from "@/components/Listing/ListingScreen/owner/UserReviewsList";

const UserReviewsModal = ({ reviewsCount, review, userId }) => {
  return (
    <Modal.ClassicOverlay className={css.bottomSheetModal} dir="rtl">
      <div className={css.popupContent}>
        <div className={css.header}>
          <div className={css.title}>تقييمات المعلن</div>
          <button className={css.closeBtn} onClick={Modal.close}>
            <Icon width={14} height={14} name="Close" />
          </button>
        </div>
        <div className={css.body}>
          <div className={css.reviewsHeader}>
            <div className={css.reviewsSummary}>
              <span>{review}</span>
              <span> ({reviewsCount} تقييم)</span>
            </div>
            <RatingStars
              value={review}
              hideLabel={true}
              isStatic
              starComponent={OutlineStar}
            />
          </div>
          <UserReviewsList userId={userId} />
        </div>
      </div>
    </Modal.ClassicOverlay>
  );
};

export default UserReviewsModal;
